import { FormGroup } from 'react-bootstrap'
import styled, { css } from 'styled-components'

import LiveTooltip from 'live/components/ui/tooltip'

export const BarrierInfoContainer = styled.div`
    i {
        color: ${({ theme }) => theme['blue-500']};
    }

    hr {
        border-bottom: 1px solid var(--gray-500);
    }

    .barrier-info-row {
        display: flex;
        flex-direction: row;
        padding-top: 8px;
        padding-bottom: 8px;

        width: 100%;
    }

    .barrier-info-col {
        display: flex;
        flex-direction: row;
    }

    .barrier {
        color: ${({ theme }) => theme['gray-900']};
        font-weight: ${({ theme }) => theme['font-bold']};
        font-size: 10px;
        &-info-id {
            padding-left: 4px;
            color: ${({ theme }) => theme['gray-600']};
            font-weight: ${({ theme }) => theme['font-regular']};
        }
        i {
            margin-left: auto;
            cursor: pointer;
            font-size: 14px;
        }
    }

    .description {
        color: ${({ theme }) => theme['gray-800']};
        font-weight: ${({ theme }) => theme['font-semibold']};
        font-size: 13px;
    }

    .info {
        font-size: 13px;
        text-align: left;

        .key {
            color: ${({ theme }) => theme['gray-600']};
            width: 50%;
        }

        .value {
            color: ${({ theme }) => theme['gray-800']};
        }
    }
`
export const Title = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 16px;

    i {
        line-height: 12px;
        font-size: 16px;
        font-weight: ${({ theme }) => theme['font-semibold']};
        color: ${({ theme }) => theme['blue-500']};
        &:hover {
            cursor: help;
        }
    }
`

export const FormField = styled(FormGroup)`
    .Select-control {
        #bowtieEditor-barrierAssignModal-field-barrierType,
        #bowtieEditor-barrierAssignModal-field-barrier {
            height: 34px;
            margin: 0px;
            padding: 0px;
        }
    }
`

export const InfoBarrierFlex = styled.div`
    display: flex;
`

export const StyledCustomTooltip = styled(LiveTooltip)`
    transform: translate(-22px, 0);
    width: calc(380px - 22px);

    > .tooltip-inner {
        width: 100%;
        max-width: 100%;
    }

    > .tooltip-arrow {
        left: unset !important;
        right: 13px;
    }
`
export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`
export const DisableableIcon = styled.i<{ disabled: boolean }>`
    ${({ disabled }) =>
        disabled
            ? css`
                  color: ${({ theme }) => theme['gray-500']};
              `
            : css`
                  color: ${({ theme }) => theme['blue-500']};
                  &:hover {
                      cursor: pointer;
                  }
              `}
    line-height: 18px;
    margin-right: 1px;
    font-size: 14px;
    font-weight: ${({ theme }) => theme['font-semibold']};
`
